import { css } from 'styled-components';

const gradients = [
    css`
        background: linear-gradient(180deg, #243c85 0%, #1b5385 61.98%);
    `,
];

export default gradients;
